export const TAcustomSearchCX = '004838229727836724704:zg86oels51g'

export const IHGcustomSearchCX = '004838229727836724704:smyk2k5kghu'

export const ChoiceCustomSearchCX = '004838229727836724704:vnidwjeeuco'

export const radissonCustomSearchCX = '004838229727836724704:kdbpuj43heu'

export const wyndhamCustomSearchCX = '004838229727836724704:lhvsxv4soex'

export const marriottCustomSearchCX = '004838229727836724704:wokegwjedrc'

export const hiltonCustomSearchCX = '004838229727836724704:ldvant46oug'

export const hyattCustomSearchCX = '1b1ae33589dc5c3c7'

export const bestwesternCustomSearchCX = '14f6c9939afcca6f7'

export const GAID =
  window.location.hostname === 'localhost' ? 'G-0XS7M5VD5T' : 'G-XQHS3WV6WL'

export const DEFAULT_SUBSIDIARY_ID = '00000000-0000-0000-0000-000000000000'
